// extracted by mini-css-extract-plugin
export default {"skip":"ForgotPassword_skip__QaxEb"};